import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { CONFIRMATION_MODE,CONFIRMATION_RESULT, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizActionObj,
  WizList,
  WizDatasource,
  WizPopUp,
  ConfirmationResultObj,
  WizRoot,
  WizEventManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent, StaticFeatureEnum, TabVO } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { EditTabPop } from '../pop/edit-tab.pop';
import { Model } from 'src/app/model/model';
import { Observable } from 'rxjs';

@Component({
  selector: 'tab-renderer',
  templateUrl: './tab.renderer.html',
})
export class TabRenderer implements IWizItemRenderer<null, WizActionObj> {
  
  context?: null;

  _data: WizActionObj;

  owner?: WizList;

  public wizIcon: string;
  public wizMaterial: string;
  public wizImage: Observable<string>;
  public description: string;
  public label: string;
  constructor(protected cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  public set data(pValue: WizActionObj) {
    this._data = pValue;
    this.feed();
  }

  public get data(): WizActionObj {
    return this._data;
  }

  // colorisation du tab
  public get lineBackground(): string {
    const actionObj = this.data;
    if (!!actionObj && !!actionObj.lineColor) {
      // return actionObj.lineColor;
      return 'linear-gradient(to bottom, #ffffffff 0%, #ffffffff 85%,' + actionObj.lineColor + ' 100%)';
    } else {
      return '#ffffff00';
    }
  }

  public get color(): string {
    return this.data?.lineColor || 'inherit';
  }

  public feed(): void {
    // this.wizIcon = this.data?.imageSource;
    try {
      let action: WizActionObj = this.data;
      if(!!action?.imageSource) {
        let parts: string[] = action.imageSource.split('|');
        if(parts.length === 1) {
          this.wizIcon = action.imageSource;
        } else {
          switch(parts[0]) {
            case 'mat':
              this.wizMaterial = parts[1];
            break;
            case 'img': 
              this.wizImage = action.imgObs;
            break;
          }
        }
      }
    } catch(e:any) {
      // console.log('btn img', action.buttonCode, action.imageSource);
    }
    
    this.label = this.data.label;
    if (this.data?.description) {
      this.description = this.data.description;
    } else {
      const tab: TabVO = Model.getInstance().tabEngine.getTabByCode(this.data.featureCode);
      if (tab) {
        this.description = tab.trsDesc || Model.getInstance().physicalTemplateEngine.getTemplate(tab.physTempCode)?.trsDesc;
      }
    }
  }

  /**
   * Synchronisation de la sélection de la ligne et celle de la checkbox
   * @returns boolean true si la ligne est sélectionnée, false sinon
   */
  public isSelected(): boolean {
    const datas: WizDatasource<WizActionObj> = this.owner.wizDataProvider;
    return datas.isSelected(this._data);
  }

  /** affichage de l'icône de suppression */
  public mayEdit(): boolean {
    return this.canCreate && this.owner.id === 'custom';
  }

  /** affichage de l'icône de suppression */
  public mayDelete(): boolean {
    return this.canDelete && this.owner.id === 'custom';
  }

  /** edition possible du tab */
  get canCreate(): boolean {
    return (
      Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.TEMPLATE) ||
      Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.TEMPLATE)
    );
  }

  /** suppression possible du tab */
  get canDelete(): boolean {
    return (
      Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.TEMPLATE)
    );
  }


  public askForDelete(e: Event): void {
    e.stopPropagation();
    e.preventDefault();
    // TODO : RGs de suppression
    WizPopUp.confirm(
      '$.delete.tab.title.$',
      '$.delete.tab.detail.$',
      this.confirmDelete.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      null,
      null,
      null
    ).show();
  }

  /**
   * Confirmation de la sélection du free data
   */
  private confirmDelete(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().tabEngine.removeTab(this._data); // on l'enlève de la tabbar
      const tabVO: TabVO = Model.getInstance().tabEngine.getTabByCode(this._data.featureCode);
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.DELETE_TAB, tabVO));
    }
  }

  public askForEdit(e: Event): void {
    e.stopPropagation();
    e.preventDefault();
    const tabVO: TabVO = Model.getInstance().tabEngine.getTabByCode(this._data.featureCode); 
    const pop: WizPopUp = new WizPopUp(
      EditTabPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '400px',
      '400px',
      tabVO
    );
    pop.setCallback(this.onTabUpdated.bind(this));
    pop.show();
  }

  private onTabUpdated(pTab: TabVO) {
    // console.log('tab updated', pTab, this.data);
    this.data.data = pTab;
    this.data.label = pTab.trsLabel;
    this.data.description = pTab.trsDesc;
    this.data.lineColor = pTab.color
    this.feed(); // refresh du thumb
    Model.getInstance().tabEngine.refreshAppearance(); // va tout refresh
    this.cdref.markForCheck();
  }
  


}
